// RelationshipUserDealerships.jsx
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";
import axios from "../../../api/axios";
import { useLocation } from "react-router-dom";

const RelationshipUserDealerships = () => {
    const { state } = useLocation();
    const { userId } = state || {};

    const [dealershipData, setDealershipData] = useState([]);

    const columns = [
        { field: 'slNo', headerName: 'SL No', width: 90 },
        { field: 'tradeName', headerName: 'Dealership', flex: 1 },
        { field: 'relationsipPerc', headerName: 'Percentage', width: 150 }
    ];

    useEffect(() => {
        if (userId) {
            fetchDealerships(userId);
        }
    }, [userId]);

    const fetchDealerships = async (userid) => {
        try {
            const response = await axios.post(
                "relationshipManager/fetchUserDealership",
                { userid }
            );

            if (response.data.sucsess === 1) {
                const formattedData = response.data.data.map((item, index) => ({
                    ...item,
                    slNo: index + 1
                }));
                setDealershipData(formattedData);
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        // <Box sx={{ marginTop:"50px",  width: "100%", display: "flex", flexDirection: "column" }}>
        //     <DataGrid
        //         rows={dealershipData}
        //         columns={columns}
        //         getRowId={(row) => row.id}
        //         hideFooterPagination   // removes pagination controls
        //         hideFooter             // removes entire footer (optional)
        //         disableRowSelectionOnClick
        //         sx={{ flex: 1 }}
        //     />
        // </Box>

        <Box sx={{ marginTop:"50px", padding: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Dealerships
      </Typography>

      <DataGrid
        rows={dealershipData}
        columns={columns}
        getRowId={(row) => row.id}
        pageSizeOptions={[5, 10, 20]}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 100, page: 0 }
          }
        }}
        sx={{ height: "80vh", width: "100%" }}
      />
    </Box>
    );
};

export default RelationshipUserDealerships;